import { MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import Post from "../../Components/Post";
import { selectIsLoading } from "../../Containers/App/selector";
import { selectProfile } from "../../Containers/Client/selector";
import { getPost } from "../../Containers/PostContainer/action";
import { selectPostData } from "../../Containers/PostContainer/selector";
import { searchAction, setUserFound } from "./action";
import { selectUserFound } from "./selector";
import Slider from "react-slick";

import style from "./style.module.scss";
import UserResult from "./components/UserResult";
import { useMediaQuery } from "@material-ui/core";

function Explore({ posts, users, profile, isLoading }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const xlSize = useMediaQuery("(min-width:1200px)");
	const [searchParams] = useSearchParams();
	const q = searchParams.get("q");
	const [searchField, setSearchField] = useState(null);
	const handleSearch = () => {
		navigate("/explore?q=" + searchField);
	};
	const redirect = () => {
		dispatch(getPost("explore", null, q));
		dispatch(setUserFound(null));
		setSearchField("");
		navigate("/explore");
	};
	useEffect(() => {
		if (q) {
			setSearchField(q)
			dispatch(searchAction(q));
		} else {
			redirect();
		}
	}, [q]);
	const sliderSetings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: xlSize ? 2 : 1,
		slidesToScroll: xlSize ? 2 : 1,
	};
	const displayContent = () => {
		if (isLoading) {
			return <div className={style.noPost}>Loading...</div>;
		}
		if (posts?.length > 0 || users?.length > 0)
			return (
				<>
					{users?.length > 0 ? (
						<>
							<h4>Peoples</h4>
							<div className={style.userResult}>
								<Slider {...sliderSetings}>
									{users?.map((user, index) => {
										return <UserResult user={user} />;
									})}
								</Slider>
							</div>
						</>
					) : null}
					<div>
						{posts.length > 0 ? <h4>Marks</h4> : null}
						{posts?.map((post, index) => {
							return (
								<Post data={post} key={index} loggedInUser={profile.username} />
							);
						})}
					</div>
				</>
			);
		return (
			<div className={style.noPost}>
				{q ? `We don't find anything like that...` : "No Mark Available..."}
			</div>
		);
	};
	return (
		<div className={style.parent}>
			<div className={style.mainContainer}>
				<div className={style.search}>
					<div className={style.searchField}>
						<input
							placeholder='Search something...'
							value={searchField}
							name='search'
							onKeyDown={(event) => {
								if (event.key === "Enter") handleSearch();
							}}
							onChange={(e) => {
								setSearchField(e.target.value);
							}}
						/>
					</div>
					<div className={style.btnSearch} onClick={handleSearch}>
						<MDBIcon fas icon='search' />
					</div>
				</div>
			</div>
			<div className={style.mainContainer}>
				{q ? (
					<p>
						Search result for '<b>{q}</b>'{" "}
						<MDBIcon
							style={{ cursor: "pointer" }}
							far
							icon='times-circle'
							onClick={redirect}
						/>
					</p>
				) : (
					""
				)}
				{displayContent()}
			</div>
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	posts: selectPostData,
	profile: selectProfile,
	isLoading: selectIsLoading,
	users: selectUserFound,
});

export default connect(mapStateToProps)(Explore);
